export const SERVICE_ENDPOINTS = {
  authz: {
    production: "https://api.superagi.com/authz",
    staging: "https://api-staging.superagi.com/authz",
    development: "http://localhost:5099/api",
  },
  crm: {
    production: "https://api.superagi.com/crm",
    staging: "https://api-staging.superagi.com/crm",
    development: "http://localhost:5082/api",
  },
  digitalEmployee: {
    production: "https://api.superagi.com/supermind",
    staging: "https://api-staging.superagi.com/supermind",
    development: "http://localhost:8105/api",
  },
  prospect: {
    production: "https://api.superagi.com/prospect",
    staging: "https://api-staging.superagi.com/prospect",
    development: "http://localhost:5105/api",
  },
  "live-assist": {
    production: "https://api.superagi.com/live-assist",
    staging: "https://api-staging.superagi.com/live-assist",
    development: "http://localhost:8090",
  },
  notes: {
    production: "https://api.superagi.com/notes",
    staging: "https://api-staging.superagi.com/notes",
    development: "http://localhost:8104/api",
  },
  views: {
    production: "https://api.superagi.com/views",
    staging: "https://api-staging.superagi.com/views",
    development: "http://localhost:5090/api",
  },
  huddle: {
    production: "https://api.superagi.com/huddle",
    staging: "https://api-staging.superagi.com/huddle",
    development: "http://localhost:5106/api",
  },
  qa: {
    production: "https://api.superagi.com/qa",
    staging: "https://api-staging.superagi.com/qa",
    development: "http://localhost:5106/api",
  },
  codeReviewer: {
    production: "https://api.superagi.com/code_reviewer",
    staging: "https://api-staging.superagi.com/code_reviewer",
    development: "http://localhost:5107/api",
  },
  codebase: {
    production: "https://api.superagi.com/codebase",
    staging: "https://api-staging.superagi.com/codebase",
    development: "http://localhost:5108/api",
  },
  codeActions: {
    production: "https://api.superagi.com/code-actions",
    staging: "https://api-staging.superagi.com/code-actions",
    development: "http://localhost:5109/api",
  },
  errorTracking: {
    production: "https://api.superagi.com/error-logging",
    staging: "https://api-staging.superagi.com/error-logging",
    development: "http://localhost:5120/api",
  },
  chat: {
    production: "https://api.superagi.com/chat",
    staging: "https://api-staging.superagi.com/chat",
    development: "http://localhost:5103/api",
  },
  codebaseGit: {
    production: "https://codebase.superagi.com",
    staging: "https://codebase-staging.superagi.com",
    development: "http://localhost:5108",
  },
  codebaseGitSsh: {
    production: "api.superagi.com",
    staging: "api-staging.superagi.com",
    development: "localhost",
  },
  esignature: {
    production: "https://api.superagi.com/esignature",
    staging: "https://api-staging.superagi.com/esignature",
    development: "http://localhost:5110/api",
  },
  agent: {
    production: "https://api.superagi.com/superagi-agent",
    staging: "https://api-staging.superagi.com/superagi-agent",
    development: "http://localhost:5111/api",
  },
  sandbox: {
    production: "https://api.superagi.com/sandbox",
    staging: "https://api-staging.superagi.com/sandbox",
    development: "http://localhost:5117/api",
  },
  inferenceRouter: {
    production: "https://api.superagi.com/inference-router",
    staging: "https://api-staging.superagi.com/inference-router",
    development: "http://localhost:8122/api",
  },
  coder: {
    production: "https://api.superagi.com/coder",
    staging: "https://api-staging.superagi.com/coder",
    development: "http://localhost:5118/api",
  },
  approvals: {
    production: "https://api.superagi.com/approvals",
    staging: "https://api-staging.superagi.com/approvals",
    development: "http://localhost:5092/api",
  },
  customDomains: {
    production: "https://api.superagi.com/custom-domains",
    staging: "https://api-staging.superagi.com/custom-domains",
    development: "http://localhost:5118/api/custom-domains",
  },
  tasks: {
    production: "https://api.superagi.com/projects",
    staging: "https://api-staging.superagi.com/projects",
    development: "http://localhost:5089/api",
  },
  campaigns: {
    production: "https://api.superagi.com/campaigns",
    staging: "https://api-staging.superagi.com/campaigns",
    development: "http://localhost:5079/api",
  },
  communication: {
    production: "https://api.superagi.com/communication-kt",
    staging: "https://api-staging.superagi.com/communication-kt",
    development: "http://localhost:8083/api",
  },
  invoices: {
    production: "https://api.superagi.com/invoices",
    staging: "https://api-staging.superagi.com/invoices",
    development: "http://localhost:5124/api",
  },
  hr: {
    production: "https://api.superagi.com/hr",
    staging: "https://api-staging.superagi.com/hr",
    development: "http://localhost:5114/api",
  },
};
